import { gsap } from "gsap";
import { EventHandler } from "./eventHandler";

const body = document.querySelector("body"),
    header = document.querySelector(".js-header"),
    headerWrapper = document.querySelector(".js-header-wrapper"),
    mainWrapper = document.querySelector(".js-main-wrapper"),
    pageContents = document.querySelector(".js-page-contents"),
    topDeducter = document.querySelector(".js-spacer"),
    info = document.querySelector(".js-info"),
    infoContents = document.querySelector(".js-info-contents"),
    infoLink = document.querySelectorAll(".js-info-link"),
    infoLinkTextual = [...infoLink].filter((link) =>
        link.classList.contains("js-info-link-textual")
    ),
    infoLinkDefaultText = "Info",
    spacingMultiplier = 3.5,
    headerStyles = header ? window.getComputedStyle(header) : null,
    introSwitchBreak = header
        ? (spacingMultiplier - 1) *
          parseInt(headerStyles.getPropertyValue("padding-bottom"))
        : null,
    reducingText = document.querySelectorAll(".js-reducing-text"),
    hasReducingText = reducingText.length,
    transitionTime = 500,
    fadeTime = 300,
    scrollTolerance = 20;

let mobile,
    prevWinScrollT,
    wrapperHeightTimeout,
    pushingContentDown,
    movingEls = [{ el: info, move: true }],
    ticking = false,
    infoShowing = false,
    introShowing = true;

export function init() {
    // Add the class to each of the paragraphs outputted by the RTE
    document
        .querySelectorAll(".js-info-block-text p")
        .forEach((el) => el.classList.add("info-block--text"));

    positionPageContents();

    if (reducingText.length) {
        EventHandler.addEventListener("scroll.infobar", onScroll, false);
    }

    toggleInfoSectionInit();

    // appendSizing(function () {
    //     // If the page contents are visible only, to prevent incorrect value set when height
    //     // of the intro text is zero
    //     if (pageContents.offsetWidth && pageContents.offsetHeight) {
    //         positionPageContents();
    //     }
    // });

    return positionPageContents;
}

function positionPageContents() {
    var top = "";

    mobile = window.innerWidth < 768 ? true : false;

    // If we are not at mobile...
    if (!mobile) {
        // Target is the bottom of the header
        top = header.clientHeight;

        if (hasReducingText) {
            // Add extra space
            top +=
                spacingMultiplier *
                parseInt(headerStyles.getPropertyValue("padding-bottom"));
        }

        // Reduce by any borders
        if (topDeducter) {
            top -= parseInt(
                window
                    .getComputedStyle(topDeducter)
                    .getPropertyValue("border-top-width")
            );
        }
    }

    // Set the top value
    pageContents.style.top = `${top}px`;
}

function applyOpacity(ratio) {
    // Ratio is the opposite (1 -) of (the ratio of the introSwitchBreak we
    // have scrolled through, max 1)
    reducingText.forEach((el) => (el.style.opacity = 1 - Math.min(ratio, 1)));
}

function updateIntro() {
    ticking = false;

    var scrollRatio = window.scrollY / introSwitchBreak;

    // If we think we are showing the intro
    if (introShowing) {
        applyOpacity(scrollRatio);

        // If we have scrolled past the point it should hide
        if (scrollRatio > 1) {
            // Set the flag
            introShowing = false;

            // After the text has had chance to fade out
            wrapperHeightTimeout = setTimeout(function () {
                // Add the wrapper class to prevent overflow
                headerWrapper.classList.add("wrapper_height-inherit");
            }, 100);
        }
        // If we think we aren't showing the intro but we have scrolled into the area
    } else if (scrollRatio < 1) {
        // Clear the adding class timeout
        clearTimeout(wrapperHeightTimeout);
        // Set the flag
        introShowing = true;
        // Remove wrapper class
        headerWrapper.classList.remove("wrapper_height-inherit");

        applyOpacity(scrollRatio);
    }
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(updateIntro);
    }
    ticking = true;
}

function onScroll() {
    requestTick();
}

// Toggle Info Section

function toggleInfoSectionInit() {
    // If we're at mobile, we always want to move the header
    if (mobile) {
        movingEls.push({ el: header, move: true });
    }

    // On clicking the info link
    infoLink.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();

            // If info is not open, open and vice-versa
            if (!infoShowing) {
                openInfo(el);
            } else {
                closeInfo(el);
            }
        });
    });
}

function transitionInfoLink($link, text) {
    infoLinkTextual.forEach(($link) => {
        let infoLinkTextualContainer = $link.parentElement,
            initialWidth = $link.offsetWidth;

        // Set the width of the container to the current text width whilst preventing any rounding issues.
        // Add the class to hide the overflow
        infoLinkTextualContainer.style.width = initialWidth;
        infoLinkTextualContainer.classList.add("prevent-overflow");

        // Fix the link in place and change its text
        $link.classList.add("place");
        $link.textContent = text;

        let newWidth = $link.offsetWidth;

        gsap.fromTo(
            infoLinkTextualContainer,
            {
                width: `${initialWidth}px`,
            },
            {
                width: `${newWidth}px`,
                duration: 0.2,
                ease: "ease",
                onComplete: function () {
                    // Unfix the text
                    $link.classList.remove("place");

                    infoLinkTextualContainer.style.width = "";
                    infoLinkTextualContainer.classList.remove(
                        "prevent-overflow"
                    );
                },
            }
        );
    });
}

function toggleTransition(state, time) {
    var on = state === "on";

    // Set the CSS transition for the elements
    // If this is on, set the transition property, time and easing,
    // otherwise, remove any inlined transitions
    movingEls.forEach((item) => {
        if (item.move) {
            item.el.style.transition = on
                ? "transform " + time + "ms ease-in-out"
                : "";
        }
    });
}

function enableTransitionForDuration() {
    toggleTransition("on", transitionTime);

    setTimeout(function () {
        toggleTransition();
    }, transitionTime);
}

function doTranslate(els, target) {
    if (!Array.isArray(els)) {
        els = [{ el: els, move: true }];
    }

    els.forEach((item) => {
        if (item.move) {
            item.el.style.transform = target
                ? "translate3d(0, " + target + "px, 0)"
                : "";
        }
    });
}

function setPositions(opening = false) {
    var targetVal = 0,
        notInfo = [];

    notInfo = movingEls.filter(
        (item) => !item.el.classList.contains("js-info")
    );

    // If we are opening, determine the targets
    if (opening) {
        if (mobile) {
            targetVal = window.innerHeight;
        } else {
            // Calculate the amount to transition by.
            // Now that info can also take the flow at desktop, if it is
            // taller than the winH, we need to use the winH to prevent
            // a jump when closing
            targetVal = Math.min(info.offsetHeight, window.innerHeight);
        }
    }

    // If we support CSS transitions
    if (mobile) {
        doTranslate(movingEls, targetVal);
    } else {
        // If we're pushing content down, we need to push it targetVal - headerHeight
        // Continue to push info down the total amount
        if (pushingContentDown) {
            doTranslate(info, targetVal);

            // doTranslate(notInfo, targetVal - (header.offsetHeight + 100));
            doTranslate(notInfo, targetVal);
        } else {
            doTranslate(movingEls, targetVal);
        }
    }
}

function resetScrollPosition() {
    // If we have a previous scroll position saved
    if (prevWinScrollT) {
        // Reset it
        window.scroll({ top: prevWinScrollT });

        // Nullify the out of date value
        prevWinScrollT = null;
    }
}

function closeInfo($link) {
    // Set a flag to say that the info is not showing
    infoShowing = false;

    // Use the header intro link
    body.classList.remove("header-switch");
    body.classList.add("closing-info");

    // Display rest of the page if it was hidden
    body.classList.remove("info-to-flow");

    // Ensuring the flow switch has had time to take place in iOS (we have
    // as long as it takes for the fade to happen to do this)
    setTimeout(function () {
        resetScrollPosition();
    }, fadeTime);

    // Re layout (no method given calls 'layout')
    // if (packeryInstance()) {
    //     sizeLockupBlocks();

    //     pckryInstance.packery();
    // }

    // Fade out the contents
    infoContents.classList.remove("reveal");

    // After the contents have faded out
    setTimeout(function () {
        // Set the text of the link
        transitionInfoLink($link, infoLinkDefaultText);

        enableTransitionForDuration();

        setPositions();

        // After it has faded back, reset the transition
        setTimeout(function () {
            // Show the real intro again
            body.classList.remove("closing-info");

            // Fade back in the reducing text
            reducingText.forEach((el) => el.classList.remove("hide"));

            // Reset the z-index of info. Explained when adding
            // info.classList.remove("bring-forward");
        }, transitionTime); // The translate time
    }, 300);

    // Remove the resize listener
    // ["resize.infobar", "scroll.infobar"].forEach((event) => {
    //     EventHandler.removeEventListener(event);
    // });
}

function checkOverflow(firstRun) {
    // For the first run, wait for the transition and fade. Otherwise, immediate
    var delay = firstRun ? transitionTime + fadeTime : 0;

    // For desktop only
    if (!mobile) {
        // If the info section is larger than the window height
        if (window.innerHeight <= info.offsetHeight) {
            // The info needs to be scrollable (we should also force the scroll position to top)
            info.classList.add("scrollable");
            info.scroll({ top: 0 });

            setTimeout(function () {
                // Move the info to the flow
                body.classList.add("info-to-flow");

                if (firstRun) {
                    window.scroll({ top: 0 });
                }
            }, delay);
            // Otherwise
        } else {
            // Remove it, as this was causing issues with not being able to
            // scroll the page behind info in Safari
            info.classList.remove("scrollable");

            body.classList.remove("info-to-flow");

            resetScrollPosition();
        }
    }
}

// function infoResize() {
//     console.log("====== INFO RESIZE ======");
//     if (infoShowing) {
//         if (mobile) {
//             // If we have come from desktop, we will need to add the flow class here
//             body.classList.add("info-to-flow");

//             // If the moving els object doesn't contain the header, add it
//             movingElsContainsHeader = movingEls.filter((el) =>
//                 el.classList.contains("js-header")
//             ).length;
//             if (!movingElsContainsHeader) {
//                 movingEls.push(header);
//             }
//         }

//         // If we are at mobile and we haven't been pushing down the contents,
//         if (mobile && !pushingContentDown) {
//             // Set the flag so this only runs once
//             pushingContentDown = true;
//             // Add it now so it is usable
//             movingEls.push(mainWrapper);

//             movingEls.push(header);
//         }

//         if (!mobile) {
//             movingEls.filter(
//                 (el) => !el.classList.contains("js-header")
//             );

//             // Set header translate to 0;
//             doTranslate(header, 0);
//         }

//         // After the info section has resized
//         setTimeout(function () {
//             checkOverflow();
//         }, 50);

//         setPositions(true);
//     }
// }

function scrollToClose() {
    var origScrollT = window.scrollY;

    // On scroll...
    window.addEventListener("scroll.info", () => {
        raf(function () {
            if (!mobile && !info.classList.contains("scrollable")) {
                // If we have scrolled [x]px either way, close it
                if (Math.abs(window.scrollY - origScrollT) > scrollTolerance) {
                    closeInfo();
                }
            }
        });
    });
}

function openInfo($link) {
    // Set the flag to say that the info is now showing
    infoShowing = true;

    // Bring the info section up so it sits over the blocks. Z-index is set
    // to auto by default to prevent painting issues when scrolling udard
    // on the play page on iOS 7
    info.classList.add("bring-forward");

    // Set the text of the link
    transitionInfoLink($link, "Close Info");

    // If we are at mobile, or desktop with the top of the page contents
    // still visible. For android stock, the page contents always move
    if (mobile || window.scrollY < introSwitchBreak) {
        // Set the flag
        pushingContentDown = true;

        // Also include the page contents
        movingEls.push({ el: mainWrapper, move: true });
    } else {
        // Set the flag
        pushingContentDown = false;

        movingEls.forEach((item) => {
            if (item.el.classList.contains("js-main-wrapper")) {
                item.move = false;
            }
        });
    }

    // Get the current scroll top for later
    prevWinScrollT = window.scrollY;

    // If we're at mobile, we always want to move the header
    if (mobile) {
        movingEls.push({ el: header, move: true });
    } else {
        // Remove the header from the moving Elements
        movingEls.forEach((item) => {
            if (item.el.classList.contains("js-header")) {
                item.move = false;
            }
        });
    }

    enableTransitionForDuration();

    body.classList.add("showing-info");

    reducingText.forEach((el) => el.classList.add("hide"));

    setPositions(true);

    checkOverflow(true);

    // After the transition
    setTimeout(function () {
        // If this is mobile
        if (mobile) {
            // Hide the rest of the page to prevent browser chromes
            // resizing and the rest of the page spilling over
            body.classList.add("info-to-flow");
            // Set the scroll position to the top of the info
            window.scroll({ top: 0 });
        }

        // Fade in the contents
        infoContents.classList.add("reveal");

        setTimeout(function () {
            // Use the inline introductory paragraph link
            body.classList.remove("showing-info");
            body.classList.add("header-switch");

            // Only allow scroll to close after all the classes have been added
            scrollToClose();
        }, fadeTime);
    }, transitionTime);

    // appendSizing(infoResize);
}
